import React from "react";
import Modal from 'react-bootstrap4-modal';

class PromoModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: true
        }
    }
    go= () => {
        window.location.href = '/buy/device';
    }
    close= () => {
        this.setState({
            visible : false
        });
    }
    render() {
        return (
            <Modal visible={this.state.visible} className="promo-modal" onClickBackdrop={this.close}>
                {/*<div className="modal-header">
          <h5 className="modal-title">Happy New Year 2021</h5>
        </div>*/}
                <div className="modal-body">
                    {/*<img src="/images/promo_safe2021.jpg" onClick={this.go} style={{cursor:"pointer", marginTop:"0px"}} alt="Mightywifi Happy New Year 2021 Promotion" />*/}
                    <span style={{color: "#EF6454"}}><strong>Winter Special (12/14 – 1/31)</strong></span>
                    <br/><br/>
                    Buy any Mightywifi Cloud Device with the Promo Data<br/>
                    You will get 1 month free of the same promo data. (US Data only)<br/>
                    The free data plan will be automatically activated after your 30-day plan expires.
                </div>
                <div className="modal-footer">
                    <button type="button" className="btn btn-primary btn-sm" onClick={this.close}>
                        Close
                    </button>
                </div>
            </Modal>
        );
    }
}

export default PromoModal;



// WEBPACK FOOTER //
// ./src/layout/PromoModal.js